<section class="auth-card" aria-labelledby="auth-pin-title">
  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <div class="auth-card__header">
      <pa-button
        icon="pi pi-arrow-left"
        variant="outlined"
        size="small"
        severity="secondary"
        aria-label="Назад"
        (click)="back()"
      />
      <div class="auth-card__intro">
        <h1 class="auth-card__title auth-card__title--left" id="auth-pin-title">
          Введите ПИН-код
        </h1>
        <p class="auth-card__subtitle">
          Код указан в профиле сотрудника. Если вы не знаете его, обратитесь к управляющему.
        </p>
      </div>
    </div>

    <div class="auth-code-field" (keydown.enter)="onCodeEnter($event)">
      <pa-input-otp
        formControlName="code"
        [length]="4"
        autocomplete="off"
        [invalid]="showPinError"
        [errorText]="showPinError ? pinErrorText : ''"
      />
    </div>

    <pa-button
      label="Войти"
      [fullWidth]="true"
      styleClass="auth-submit"
      [disabled]="isCodeSubmitDisabled()"
      (click)="submit()"
    />

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </form>
</section>
